import React from 'react';
import styled from 'styled-components';
import { Spinner } from './Spinner';

const StyledFullscreenLoading = styled.div`
    left: 0;
    top: 0;
    position: fixed;
    height: 100vh;
    width: 100vw;
    background-color: rgba(164, 164, 164, 0.66);
    backdrop-filter: blur(2px) grayscale(0.4);
    z-index: 600;

    display: flex;
    align-items: center;
    justify-content: center;
`;

export const FullScreenLoading = () => {
    return (
        <StyledFullscreenLoading>
            <Spinner />
        </StyledFullscreenLoading>
    );
};
